import { useEffect } from "react";
import "./App.css";
import {
    CommunicationIdentifier,
  MicrosoftTeamsAppIdentifier,
} from "@azure/communication-common";
import {
  Spinner,
  Stack,
  initializeIcons,
  registerIcons,
} from "@fluentui/react";
import { CallAdd20Regular, Dismiss20Regular } from "@fluentui/react-icons";
// import logo from "./components/CSULBShark.png";
import logo from "./components/DoIT.png"
import { createUserAndToken } from "./components/createUserAndToken";
import { CallingWidgetComponent } from "./components/CallingWidgetComponent";
import { useLocalStorage } from "react-use";

registerIcons({
  icons: { dismiss: <Dismiss20Regular />, callAdd: <CallAdd20Regular /> },
});
initializeIcons();

function App() {
  const [identityId, setIdentityId] = useLocalStorage<string>("identityId", "");
  const [usertoken, setUserToken] = useLocalStorage<string>("userToken", "");
  const [expiresOn, setExpiresOn] = useLocalStorage<string>("expiresOn", "");
  // console.log("User token: ", usertoken, "Identity ID: ", identityId);

  useEffect(() => {
    const fetchUserAndToken = async () => {
      try {
        const { identityid, userToken, expiresOn } = await createUserAndToken();
        setIdentityId(identityid);
        setUserToken(userToken);
        setExpiresOn(expiresOn);
      } catch (error) {
        console.error("Error fetching user and token:", error);
      }
    };
    
    const isTokenExpired = () => {
       if(!expiresOn) return true;
       const expiryDate = new Date(expiresOn);
       const currentDate = new Date();
       const utcCurrentDate = new Date(currentDate.toUTCString());
       return utcCurrentDate >= expiryDate;
    }
    // Check if usertoken is not set or is an empty string
    if (!usertoken || !identityId || isTokenExpired()) {
      fetchUserAndToken();
    }
  }, [identityId, setIdentityId, setUserToken, usertoken, expiresOn, setExpiresOn]);

  const token = usertoken ?? "";

  /**
   * User identifier for local user.
   */
  const userId: CommunicationIdentifier = {
    communicationUserId: identityId ?? "",
  };

  const teamsAppIdentifier: MicrosoftTeamsAppIdentifier = {
    teamsAppId: "d260c8b6-974c-47dd-9a46-da1fa46c60b0",
    cloud: "public",
  };

  const userDisplayName: string = new URLSearchParams(window.location.search).get("username") ?? "";

  const widgetParams = {
    userId,
    token,
    teamsAppIdentifier,
    userDisplayName,
  };

  if (!token || !userId.communicationUserId || !teamsAppIdentifier.teamsAppId) {
    return (
      <Stack verticalAlign="center" style={{ height: "100%", width: "100%" }}>
        <Spinner
          label={"Getting user credentials from server"}
          ariaLive="assertive"
          labelPosition="top"
        />
      </Stack>
    );
  }

  return (
    <Stack style={{ height: "85%", width: "100%" }} tokens={{ childrenGap: "1.5rem" }}>
      <Stack
        horizontal
        tokens={{ childrenGap: "1.5rem" }}
        style={{ overflow: "hidden", margin: "auto" }}
      >
        <CallingWidgetComponent
          widgetAdapterArgs={widgetParams}
          onRenderLogo={() => {
            return (
              <img
                style={{ height: "4rem", width: "4.5rem", margin: "5px 0 0 45px" }}
                src={logo}
                alt="CSULB DoIT logo"
              />
            );
          }}
        />
      </Stack>
    </Stack>
  );
}

export default App;
